import React, { useState } from "react";
import styled from "styled-components";
import {
  Box,
  Button,
  Heading,
  Image,
  Link,
  Text,
  Flex,
} from "rebass/styled-components";
import Page from "../../components/Page";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Table from "../../components/Table";
import ContentBox from "../../components/ContentBox";
import ReactPlayer from "react-player";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-regular-svg-icons";

const ImageBox = styled(Image)`
  padding: 0;
  width: 100%;
  vertical-align: middle;
`;

const imgPath = "https://merletimages.imgix.net/";

const DesinfecterendeAlcoholHandHuid = ({ pageContent, lang }) => {
  const createMarkup = (content) => {
    return { __html: content };
  };

  return (
    <Page
      title="MERLET | Herbruikbare Mondmaskers"
      description="100% katoen – uitwasbaar op minimum 60°C, gemaakt in ons eigen atelier, al dan niet gepersonaliseerd."
    >
      <Header />
      <ContentBox bg="gold" maxWidth="inherit" pt="130px" textAlign="center">
        <Heading variant="title" color="black" textAlign="center">
          PBM
        </Heading>
        <Box variant="slogan">Desinfecterende Alcohol 70%</Box>
        <Heading variant="title" color="black" textAlign="center">
          Oxyclean voor hand & huid
        </Heading>
      </ContentBox>
      <ContentBox>
        <Box py={4} variant="intro">
          Dit is een Belgisch product!
        </Box>
        <Flex
          mb="5"
          sx={{ flexDirection: ["column", "row", "row"], textAlign: "center" }}
        >
          <Box p={2} width={[1, 1 / 2, 1 / 2]}>
            <Image
              src="https://merletimages.imgix.net/Oxyclean-RTU-disinfectant-500ml.jpg"
              maxWidth={["250px", "100%"]}
            />
          </Box>
          <Box p={2} width={[1, 1 / 2, 1 / 2]}>
            <Image
              src="https://merletimages.imgix.net/Oxyclean-HS-disinfectant-5L.jpg"
              maxWidth={["250px", "100%"]}
            />
          </Box>
        </Flex>
      </ContentBox>
      <ContentBox bg="duckEggBlue">
        <Box display="flex" flexWrap="wrap" my={4}>
          <Box px={2} flexBasis={["100%", "50%"]} mt={2}>
            <Heading variant="title" as="h2" mb="2" sx={{ color: "dark" }}>
              PRIJZEN - 500ml sprays
            </Heading>
            <Text fontSize="1" my="2">
              excl. 6% BTW (70% alcohol)
            </Text>
            <Table sx={{ bg: "gold" }}>
              <thead>
                <tr>
                  <th></th>
                  <th>Stukprijs</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Per stuk</th>
                  <td>€ 9,42</td>
                </tr>
                <tr>
                  <th>Per 12 stuks – 1 karton</th>
                  <td>€ 7,31</td>
                </tr>
                <tr>
                  <th>Per 60 stuks – 5 kartons</th>
                  <td>€ 5,90</td>
                </tr>
                <tr>
                  <th>Grotere aantallen</th>
                  <td>op aanvraag</td>
                </tr>
              </tbody>
            </Table>
          </Box>
          <Box px={2} flexBasis={["100%", "50%"]} mt={2}>
            <Heading variant="title" as="h2" mb="2" sx={{ color: "dark" }}>
              PRIJZEN - 1 liter flessen met pompjes
            </Heading>
            <Text fontSize="1" my="2">
              excl. 6% BTW (70% alcohol)
            </Text>
            <Table sx={{ bg: "gold" }}>
              <thead>
                <tr>
                  <th></th>
                  <th>Stukprijs</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Per stuk</th>
                  <td>€ 15,34</td>
                </tr>
                <tr>
                  <th>Per 12 stuks – 1 karton</th>
                  <td>€ 12,00</td>
                </tr>
                <tr>
                  <th>Per 60 stuks – 5 kartons</th>
                  <td>€ 9,74</td>
                </tr>
                <tr>
                  <th>Grotere aantallen</th>
                  <td>op aanvraag</td>
                </tr>
              </tbody>
            </Table>
          </Box>
          <Box px={2} flexBasis={["100%", "50%"]} mt={[0, 4]} sx={{ pt: 2 }}>
            <Heading variant="title" as="h2" mb="2" sx={{ color: "dark" }}>
              PRIJZEN - 5 liter bidons
            </Heading>
            <Text fontSize="1" my="2">
              excl. 6% BTW (70% alcohol)
            </Text>
            <Table sx={{ bg: "gold" }}>
              <thead>
                <tr>
                  <th></th>
                  <th>Stukprijs</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Per stuk</th>
                  <td>€ 53,77</td>
                </tr>
                <tr>
                  <th>Per 3 stuks – 1 karton</th>
                  <td>€ 42,45</td>
                </tr>
                <tr>
                  <th>Per 15 stuks – 5 kartons</th>
                  <td>€ 34,91</td>
                </tr>
                <tr>
                  <th>Grotere aantallen</th>
                  <td>op aanvraag</td>
                </tr>
              </tbody>
            </Table>
          </Box>
        </Box>
        <Box display="flex" flexWrap="wrap" my={4}>
          <Box flexBasis={["100%", "50%"]} mt={2}>
            <Heading variant="title" as="h2" mb="2" sx={{ color: "dark" }}>
              LEVERING
            </Heading>
            <Text as="ul" mt={2}>
              <Text as="li">
                Af te halen in Oud-Turnhout of Kasterlee met voorafbetaling
              </Text>
              <Text as="li">Verzending via GLS, transportkost op aanvraag</Text>
            </Text>
          </Box>
          <Box flexBasis={["100%", "50%"]} mt={2} pl={[0, 4]}>
            <Heading variant="title" as="h2" mb="2" sx={{ color: "dark" }}>
              BETALINGSVOORWAARDE
            </Heading>
            <Text as="ul" mt={2}>
              <Text as="li">
                Voorafbetaling op rek. BE67 2300 3278 3087
                <br />+ vermelding naam besteller
              </Text>
            </Text>
          </Box>
        </Box>
      </ContentBox>
      <ContentBox>
        <Heading variant="title" as="h2" mb="2" sx={{ color: "dark" }}>
          RECLAMESPOT:
        </Heading>
        <Box py={3}>
          <ReactPlayer
            url="https://youtu.be/ignQYkdXyQU"
            controls={true}
            width="100%"
            height="500px"
          />
        </Box>
      </ContentBox>

      <Box
        py="53px"
        maxWidth="inherit"
        textAlign="center"
        sx={{ bg: "duckEggBlue" }}
      >
        <Box
          min-height="96px"
          //maxWidth="792px"
          mx="auto"
          px="3"
          mb="4"
          sx={{ color: "dark", fontSize: "5", lineHeight: "1.17" }}
        >
          Te bestellen via
        </Box>
        <Link href="mailto:pascale@merlet.be">
          <Button variant="buttons.primary">pascale@merlet.be</Button>
        </Link>
      </Box>
      <Footer />
    </Page>
  );
};

export default DesinfecterendeAlcoholHandHuid;
